import z from "zod";
import { requiredNumber } from "../lib/schemas";
export const providersSummaryOutputSchema = z.object({
    total: requiredNumber,
    operating: requiredNumber,
    compliant: requiredNumber,
    at_risk: requiredNumber,
    non_compliance: requiredNumber,
    obsoletes: requiredNumber,
});
export const complianceSummaryOutputSchema = z.object({
    total: requiredNumber,
    current: requiredNumber,
    submitted: requiredNumber,
    at_risk: requiredNumber,
    pending: requiredNumber,
    expired: requiredNumber,
});
